import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => {
    return state[NAME];
};

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getIsOpenModal = createSelector(
    getModel,
    (model) => model.isOpenModal,
);

export const getIsNewRecord = createSelector(
    getModel,
    (model) => model.isNewRecord,
);

export const getContacts = createSelector(getModel, (model) => model.contacts);

export const getIsFetchingContacts = createSelector(
    getContacts,
    (contacts) => contacts.isFetching,
);

export const getContactsData = createSelector(
    getContacts,
    (contacts) => contacts.data,
);

export const getSaveProject = createSelector(
    getModel,
    (model) => model.saveProject,
);

export const getSaveProjectData = createSelector(
    getSaveProject,
    (saveProject) => saveProject.data,
);

export const getProjectIsSaving = createSelector(
    getSaveProject,
    (saveProject) => saveProject.isSaving,
);

export const getSaveProjectErrors = createSelector(
    getSaveProject,
    (saveProject) => saveProject.errors,
);

/* Geocode */
export const getFetchGeocode = createSelector(
    getModel,
    (model) => model.fetchGeocode,
);

export const getFetchGeocodeData = createSelector(
    getFetchGeocode,
    (data) => data.data || [],
);

export const showGeocodeResults = createSelector(
    getModel,
    (model) => model.showGeocodeResults,
);

export const getGeocodePointModel = createSelector(
    getModel,
    (model) => model.fetchGeocodePoint,
);

export const getIsFetchingGeocodePoint = createSelector(
    getGeocodePointModel,
    (model) => model.isFetching,
);

export const getGeocodePointData = createSelector(
    getGeocodePointModel,
    (model) => model.data,
);

export const getGeocodePointErrors = createSelector(
    getGeocodePointModel,
    (model) => model.errors,
);
